export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[900px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20product%20flatlay%20featuring%20fashion%20accessories%20scattered%20artistically%20across%20a%20textured%20linen%20surface%2C%20leather%20watch%2C%20sunglasses%2C%20small%20leather%20goods%2C%20gold%20tone%20jewelry%20pieces%2C%20soft%20directional%20window%20light%20casting%20long%20shadows%2C%20rich%20terracotta%20and%20sand%20color%20palette%2C%20editorial%20luxury%20catalog%20aesthetic%2C%20plenty%20of%20negative%20space%20for%20text%20overlay&width=1920&height=1080&seq=hero-main-v2-vb&orientation=landscape"
        alt="VigorBuy Spreadsheet products collection featuring premium fashion items"
        title="VigorBuy Spreadsheet Products Collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-black/75"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-accent-500 text-xs font-semibold uppercase tracking-wider whitespace-nowrap">Updated Daily · June 2026</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6">
          VigorBuy Spreadsheet
          <br />
          <span className="text-accent-500 italic">2026</span>
        </h1>

        <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-4 leading-relaxed">
          Discover the largest collection of <strong className="text-white font-semibold">VigorBuy Spreadsheet</strong> links, trusted sellers, and quality products in one place.
        </p>

        <p className="text-base text-white/60 max-w-xl mx-auto mb-10 leading-relaxed">
          Updated daily with the newest finds, verified sellers, and comprehensive shopping guides for every category.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-5 mb-10">
          {['Trusted Sellers', 'QC Photos', 'Updated Links', 'Worldwide Shipping'].map((item) => (
            <span key={item} className="flex items-center gap-2 text-sm text-white/75 whitespace-nowrap">
              <i className="ri-checkbox-circle-fill text-accent-500"></i>
              {item}
            </span>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold whitespace-nowrap hover:bg-accent-600 transition-all duration-300 cursor-pointer hover:scale-105"
          >
            Browse Spreadsheet <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full text-base font-semibold whitespace-nowrap hover:bg-white/25 transition-all duration-300 cursor-pointer hover:scale-105"
          >
            Visit VigorBuy <i className="ri-external-link-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}